// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import BTDLandingPage from './components/BTDLandingPage';
import BTDTheory from './components/BTDTheory';
import AGIApplications from './components/AGIApplications';
import GeneticEvolution from './components/GeneticEvolution';
import SignIn from './components/SignIn';
import KnowledgeChat from './components/KnowledgeChat';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/btd" element={<BTDLandingPage />} />
          <Route path="/btd/theory" element={<BTDTheory />} />
          <Route path="/btd/agi" element={<AGIApplications />} />
          <Route path="/btd/genetics" element={<GeneticEvolution />} />
          <Route path="/signin" element={<SignIn />} />
          <Route 
            path="/knowledge-chat" 
            element={
              <ProtectedRoute>
                <KnowledgeChat />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;